import { i18n as _i18n } from "@lingui/core";
import { formNames, MktSelectors } from '@wkda/carlead-creation-form';
import { useRef } from 'react';
import { useField } from 'react-final-form';
import { useCarleadConfiguration } from '../hooks/useCarleadCreationConfiguration';
import { useCarleadFieldChangedTracking } from '../hooks/useCarleadFieldChangedTracking';
import { BaseField } from './BaseField';
import { emailWithSuggestionInputRenderer } from './fieldRenderers/emailWithSuggestionRenderer';
import { textInputRenderer } from './fieldRenderers/textInputRenderer';
import { useStateMachineForFields } from './hooks/useStateMachineForFields';
import { Trans } from '@lingui/react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function Email(_ref) {
  let {
    label = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.email'
    }),
    placeholder = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.placeholder.email'
    }),
    className,
    onChange,
    disabled,
    ...props
  } = _ref;
  const {
    emailSuggestionEnabled
  } = useCarleadConfiguration();
  const name = formNames.email;
  const formField = useField(name);
  const {
    isFieldEnabled,
    stateFieldClassNames,
    sendSelect,
    sendFocus,
    fillInput
  } = useStateMachineForFields({
    name
  });
  const trackLeadFieldChanged = useCarleadFieldChangedTracking();
  const internalPreviousValue = useRef('');
  const isEmailSuggestionEnabled = !formField.meta.invalid && emailSuggestionEnabled;
  function onFocus(e) {
    sendFocus();
    internalPreviousValue.current = e.target.value;
  }
  function onBlur(e) {
    if (internalPreviousValue.current !== e.target.value) {
      trackLeadFieldChanged(name, 'user');
    }
    sendSelect(e.target.value);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BaseField, {
      label: label,
      name: name,
      MktSelector: MktSelectors.email,
      topContainerClassName: stateFieldClassNames,
      disabled: disabled || !isFieldEnabled,
      renderFieldComponent: function fieldRenderer(_ref2) {
        let {
          name,
          mktSelector,
          ...rest
        } = _ref2;
        return emailWithSuggestionInputRenderer({
          name,
          mktSelector,
          placeholder,
          emailSuggestionEnabled: isEmailSuggestionEnabled,
          className,
          onFocus,
          onBlur,
          id: name,
          disabled: disabled || !isFieldEnabled,
          onChange(value) {
            onChange?.({
              name,
              value
            });
            fillInput(value);
            // close google one-tap prompt
            window?.google?.accounts?.id?.cancel?.();
          },
          onSuggestion(email) {
            onChange?.({
              name,
              value: email
            });
            sendSelect(email);
            trackLeadFieldChanged(name, 'user');
            // close google one-tap prompt
            window?.google?.accounts?.id?.cancel?.();
          },
          renderLabel(email) {
            return /*#__PURE__*/_jsx(Trans, {
              id: "carlead.emailSuggestion.label",
              values: {
                email
              }
            });
          },
          buttonText: /*#__PURE__*/_jsx(Trans, {
            id: "carlead.emailSuggestion.buttonText"
          }),
          ...rest
        });
      },
      ...props
    }), /*#__PURE__*/_jsx(RepeatEmail, {})]
  });
}

// Honeypot email with convincing name :)
function RepeatEmail() {
  const {
    featuresFlags: {
      honeyPotEmail
    }
  } = useCarleadConfiguration();
  if (honeyPotEmail === false) {
    return null;
  }
  const placeholder = _i18n._(
  /*i18n*/
  {
    id: 'carleadCreation.form.placeholder.honeypot'
  });
  return /*#__PURE__*/_jsx(BaseField, {
    label: _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.honeypot'
    }),
    topContainerClassName: "repeat-email-field--hp",
    name: formNames.honeyPotEmail,
    MktSelector: MktSelectors[formNames.honeyPotEmail],
    renderFieldComponent: function fieldRenderer(_ref3) {
      let {
        name
      } = _ref3;
      return textInputRenderer({
        name,
        placeholder,
        id: name
      });
    }
  });
}